const axios = require("axios");

const Newsletter = async (email) => {
  try {
    const response = await axios.post(
        `${process.env.GATSBY_API_URL}/api/newsletter`,
      {
        email: email,
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

module.exports = { Newsletter };
